module.exports = __webpack_public_path__ + "img/benefit_pre-game-tailgate.b60e869a.jpg";